module.exports = __webpack_public_path__ + "static/media/16UNODC37.f280e6a7.jpg";